// @ts-ignore
import {Link} from "react-router-dom";
import React from "react";
import {Button, Sheet, Stack, Typography} from "@mui/joy";
import {Error} from "@mui/icons-material";

function NotFoundPage(): React.ReactElement {
    return (
        <Sheet>
            <Stack
                height='100vh'
                direction="column"
                spacing={0.5}
                alignItems={{md: "center", xs: "center"}}
                justifyContent={{lg: "center", xs: "center"}}
                paddingX={5}
            >
                <Error/>
                <Typography fontWeight='lg' fontSize='128px' textAlign='center'>
                    404
                </Typography>
                <Typography fontWeight='lg' level='h2' textAlign='center'>
                    Not Found!
                </Typography>
                <Typography level='body-sm' textAlign='center'>
                    The page requested could not be found on this website.
                </Typography>
                <br/>
                <Link style={{textDecoration: "none"}} to="/">
                    <Button size='sm' color='neutral' variant="soft">
                        Go Home
                    </Button>
                </Link>
            </Stack>
        </Sheet>
    );
}

export default NotFoundPage;
